import showKey from './showKey'
const showText = new Map(
  [
    [showKey.murongziying, "人生一场虚空大梦，韶华白首，不过转瞬，唯有天道恒在，循环往复，不曾更改。"]
    ,[showKey.wusheng, "我突然顿悟，一个人，想要的东西不能太多。但我的一生，是抗争的一生。"]
    ,[showKey.kobe, "你知道洛杉矶凌晨四点钟是什么样子吗？"]
    ,[showKey.xzNot, "你好~我是你的朋友~~小障"]
    ,[showKey.xzSuccess,"你输入的指令已~成功执行！！ ~~嘿嘿嘿~"]
    ,[showKey.xzing,"小障正在~拼尽全力~~执行你的指令。。。"]
    ,[showKey.xzWarning,"可能有~部分指令~~未能成功执行。。。"]
    ,[showKey.xzError,"指令未能成功执行~请尝试对~~指令或参数~进行调整。。。"]
  ]
)
export default showText



// WEBPACK FOOTER //
// ./src/cnConst/showText.js